import SellerEditForm from "./seller-edit-form";

export default SellerEditForm;